import Description2 from "./Description2";
export default Description2;